import { CopyToClipboard } from '@magnetic/copy-to-clipboard';
import { useClassNames } from '@magnetic/hooks';
import { IconContext, CopySimple } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import '@magnetic/theme';
import './style.css.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Inline = forwardRef(
  ({ children, copy = false, size = "md", ...rest }, ref) => {
    const codeClassNames = useClassNames(
      "mds-code-inline",
      `mds-code-inline-${size}`
    );
    const iconClassNames = useClassNames(
      "mds-code-icon-button",
      `mds-code-icon-${size}`
    );
    const CopySimpleIcon = /* @__PURE__ */ __name(() => /* @__PURE__ */ React.createElement(
      IconContext.Provider,
      {
        value: {
          weight: "bold",
          size: size === "md" ? 16 : 14,
          color: "var(--interact-icon-weak-default)"
        }
      },
      /* @__PURE__ */ React.createElement(CopySimple, null)
    ), "CopySimpleIcon");
    return /* @__PURE__ */ React.createElement("code", { className: codeClassNames, ref, ...rest }, children, copy && /* @__PURE__ */ React.createElement(
      CopyToClipboard.IconOnly,
      {
        className: iconClassNames,
        icon: /* @__PURE__ */ React.createElement(CopySimpleIcon, null),
        value: children
      }
    ));
  }
);
Inline.displayName = "Code.Inline";

export { Inline };
//# sourceMappingURL=index.js.map
